<template>
  <div class="d-flex">
    <v-select
      v-model="type"
      :items="items"
      :prepend-icon="icon"
      hide-details
      solo-inverted
      return-object
      dense
    />
  </div>
</template>

<script>
export default {
  computed: {
    type: {
      get() {
        return this.$store.state.filters.bonusReportType;
      },
      set(type) {
        this.$store.commit("setBonusReportType", type);
      },
    },
    items() {
      return [
        { text: this.$t("all"), value: "all" },
        { text: this.$t("startBonus"), value: "ativacao" },
        { text: this.$t("transfers"), value: "transferencia" },
      ];
    },
    icon() {
      return "mdi-swap-horizontal";
    },
  },
};
</script>
